import React, { useState, useEffect, useCallback } from 'react';
import { Typography, Button, Tooltip, Chip, Paper} from '@mui/material';
import Grid from '@mui/material/Grid2';
import { myApi } from '../../../config/axiosConfig';
import useMediaQuery from '@mui/material/useMediaQuery';
import Swal from 'sweetalert2';
import MiTabla from '../../../components/plantilla/tabla/MiTabla';
import { green, red } from '@mui/material/colors';
import BtnAcciones from '../../../components/plantilla/tabla/BtnAcciones';

// Iconos
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import CrearEditarUsuarioModal from './modales/CrearEditarUsuarioModal';

const Usuarios = () => {

    const isNonMobile = useMediaQuery("(min-width:600px)");

    const [dataUsuarios, setDataUsuarios] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);


    const handleOpenModal = (user = null) => {
        setSelectedUser(user);
        setIsEditing(!!user);
        setModalOpen(true);
    };

    const handleDelete = useCallback(async (id) => {
        try {
            Swal.fire({
                title: '¿Estás seguro de eliminar el usuario?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Si, eliminar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: 'green',
                cancelButtonColor: 'red',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let { data } = await myApi.delete(`/usuarios/eliminarUsuario/${id}`);

                    if (data.success) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Usuario eliminado',
                        });

                        setDataUsuarios(dataUsuarios.filter(user => user.id !== id));
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al eliminar el usuario',
                        });
                    }
                }
            });
            
        } catch (error) {
            console.error('Error deleting user:', error);
        }
    }, []);

    const handleEdit = useCallback(async (userRow) => {
        handleOpenModal(dataUsuarios.find(user => user.id === userRow.id));
        setIsEditing(true);
        setSelectedUser(userRow);
        
    }, []);

    const columns = [
        {
            field: 'nombreCompleto', headerName: 'Nombre',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { field: 'email', headerName: 'Email',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { field: 'nombre_perfil', headerName: 'perfil asignado',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'estado', headerName: 'Estatus', flex: 1,
            headerAlign: "center",
            align: "center",
            valueFormatter: (value) => {
                if (value == 1) {
                    return 'Activo';
                }else{
                    return 'Inactivo';
                }
            },
            renderCell: (params) => {
                const value = params.value;
                if (value == 1) {
                    return <Chip label="Activo" style={{ backgroundColor: green[500], color: 'white' }} />;
                } else {
                    return <Chip label="Inactivo" style={{ backgroundColor: red[500], color: 'white' }} />;
                }
            }
        },
        {
            field: 'actions',
            headerName: 'Acciones',
            type: 'actions',
            width: 150,
            getActions: (params) => [
                <BtnAcciones
                    icon={<BorderColorIcon />}
                    label="Editar"
                    onClick={() => handleEdit(params.row)}
                />,
                <BtnAcciones
                    icon={<DeleteIcon />}
                    label="Eliminar"
                    onClick={() => handleDelete(params.row.id)}
                />
            ],
        }
    ];

    const fetchUsuarios = async () => {
        try {
            const response = await myApi.get('/usuarios/getUsuarios');
            setDataUsuarios(response.data.data);
        } catch (error) {
            console.error('Error fetching usuarios:', error);
        }
    };

    const handleRowClick = (params) => {

    }

    useEffect(() => {
        fetchUsuarios();
    }, []);
    return (
        <Paper sx={{padding: 2}}>
            <Grid container>
                <Grid size={{ xs: 12, md: 8 }}>
                    <Typography variant="h4" fontWeight="bold" marginBottom={2}>
                        Usuarios
                    </Typography>
                </Grid>
                <Grid item size={{ xs: 12, md: 4 }}
                    sx={{
                        display: 'flex',
                        justifyContent: isNonMobile ? 'flex-end' : 'start'
                    }}>
                    <Button
                        variant="contained"
                        startIcon={<AddCircleIcon />}
                        onClick={() => handleOpenModal()}
                        sx={{ backgroundColor: 'black', marginBottom: 1 }}
                    >
                        Agregar Usuario
                    </Button>
                </Grid>
                {/** {LISTA DE USUARIOS} */}
                <Grid size={12}
                    marginTop={1}>
                    <MiTabla
                        columns={columns}
                        data={dataUsuarios}
                        rowClick={handleRowClick}
                    />
                </Grid>
                {/* {MODAL EDITAR/CREAR} */}
                <CrearEditarUsuarioModal
                    open={modalOpen}
                    onClose={() => setModalOpen(false)}
                    refresh={fetchUsuarios}
                    usuario={selectedUser}
                    isEditing={isEditing}
                />
            </Grid>
        </Paper>

    )

}

export default Usuarios